import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';
import { LayoutAlternative } from '@thive/fddm-types';

export type State = {
  floorPlanGroups: LayoutAlternative[];
  floorplanIdBeingDuplicatedState: string | null;
  floorplanIdsBeingDeletedState: string[];
  selectedFloorplanIdsState: string[];
  searchState: string;
  positionState: {
    x: number;
    y: number;
  } | null;
};

const INITIAL_STATE: State = {
  floorPlanGroups: [],
  floorplanIdBeingDuplicatedState: null,
  floorplanIdsBeingDeletedState: [],
  selectedFloorplanIdsState: [],
  searchState: '',
  positionState: null,
};

type Actions = {
  setFloorPlanGroups(value: State['floorPlanGroups']): void;
  setFloorplanIdBeingDuplicatedState(value: State['floorplanIdBeingDuplicatedState']): void;
  setFloorplanIdsBeingDeletedState(value: State['floorplanIdsBeingDeletedState']): void;
  setSelectedFloorplanIdsState(value: State['selectedFloorplanIdsState']): void;
  setSearchState(value: State['searchState']): void;
  setContextMenuPosition(value: State['positionState']): void;

  reset(): void;
};

export const useFloorplanAdminStore = create<State & Actions>()(
  devtools(
    (set) => ({
      ...INITIAL_STATE,

      setFloorPlanGroups(alternatives) {
        set(
          {
            floorPlanGroups: alternatives,
          },
          undefined,
          {
            type: 'layoutAlternatives/set',
          },
        );
      },

      setFloorplanIdBeingDuplicatedState(id) {
        set(
          {
            floorplanIdBeingDuplicatedState: id,
          },
          undefined,
          {
            type: 'layoutAlternatives/beingDuplicated/id/set',
          },
        );
      },

      setFloorplanIdsBeingDeletedState(ids) {
        set(
          {
            floorplanIdsBeingDeletedState: ids,
          },
          undefined,
          {
            type: 'layoutAlternatives/beingDeleted/ids/set',
          },
        );
      },

      setSelectedFloorplanIdsState(ids) {
        set(
          {
            selectedFloorplanIdsState: ids,
          },
          undefined,
          {
            type: 'layoutalternatives/selected/ids/set',
          },
        );
      },

      setSearchState(items) {
        set(
          {
            searchState: items,
          },
          undefined,
          {
            type: 'search/set',
          },
        );
      },

      // TODO: rename method to contextMenuPositionState
      setContextMenuPosition(value) {
        set(
          {
            positionState: value,
          },
          undefined,
          {
            type: 'contextMenuPosition/set',
          },
        );
      },

      reset() {
        set(INITIAL_STATE, undefined, {
          type: 'reset',
        });
      },
    }),
    { store: 'floorplanAdminStore', ...DEVTOOLS_OPTIONS },
  ),
);
